module.exports = __webpack_public_path__ + "static/WhenThePastWasAround1-517e6bda063f817dbebd3913981216d4.png";